var VERSION = 1783993754026
export  {
	VERSION
} 
